module.exports = __webpack_public_path__ + "img/icon-horn@2x.0efd4b1.png";